import { render } from "./file-share-view.vue?vue&type=template&id=3c50e526&lang=pug"
import script from "./file-share-view.vue?vue&type=script&lang=js"
export * from "./file-share-view.vue?vue&type=script&lang=js"

import "./file-share-view.vue?vue&type=style&index=0&id=3c50e526&lang=scss"

import exportComponent from "C:\\m-tech\\WMExtranet2.0\\WebUI\\WiseApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__